export default {
  container: {
    paddingBottom: '2rem',
    width: '100vw',
    minHeight: '100vh',
  },
  content: {
    margin: 'auto',
    padding: '2rem 0 0',
    width: 500,
    maxWidth: '90vw',
  },
  loadingContainer: {
    margin: 'auto',
    width: 150,
  },
  submitContainer: {
    textAlign: 'center',
    marginTop: '2rem',
  },
  loadingButtonProgress: { position: 'absolute' },
  recaptcha: {
    display: 'flex',
    justifyContent: 'center',
  },
};

